/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { FilterEngineHistoryState } from "./type";

const INITIAL_STATE: FilterEngineHistoryState = {
  filters: {
    search: "",
    type_request: "",
    type_solicitation: "",
    created_at: "",
    meta: {
      page: 1,
      perPage: 10,
    },
  },
};

type FiltersKey = keyof FilterEngineHistoryState["filters"];

const filterEngineHistory = createSlice({
  name: "filters",
  initialState: INITIAL_STATE,
  reducers: {
    setFilter(state, action: PayloadAction<{ key: FiltersKey; value: any }>) {
      state.filters[action.payload.key] = action.payload.value;
    },
    resetFilters(state) {
      state.filters = INITIAL_STATE.filters;
    },
    setPagination(
      state,
      action: PayloadAction<{ page: number; perPage: number }>
    ) {
      state.filters.meta = action.payload;
    },
  },
});

export const { setFilter, resetFilters, setPagination } =
  filterEngineHistory.actions;
export default filterEngineHistory.reducer;
